(function (slideshare_object) {
  'use strict';

  function amplitudeUserIdentify() {
    if (slideshare_object.user && slideshare_object.user.loggedin) {
      amplitude.getInstance().setUserId(slideshare_object.user.id);
    } else {
      amplitude.getInstance().setUserId(null);
    }

    const identity = new amplitude.Identify();
    identity.set("scribd_subscriber", slideshare_object.user && slideshare_object.user.scribd_subscriber);
    identity.set("connected_with_scribd", slideshare_object.user && slideshare_object.user.connected_with_scribd);

    amplitude.getInstance().identify(identity);
  }

  if (typeof amplitude !== 'undefined') {
    amplitudeUserIdentify();
  }
})(window.slideshare_object);
